/**
 * Fetches plain text and throws on non-OK response.
 */
export const fetchText = async (url: string): Promise<string> => {
  const res = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!res.ok) throw new Error(`Request failed: ${url} (${res.status})`)
  return res.text()
}

/**
 * Fetches JSON and throws on non-OK response. Use with React Query.
 */
export const fetchJson = async <T>(url: string): Promise<T> => {
  const res = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!res.ok) throw new Error(`Request failed: ${res.status}`)
  return (await res.json()) as T
}

/**
 * Fetches text; returns fallback on error or non-OK response.
 */
export const fetchOr = async (url: string, fallback: string): Promise<string> => {
  try {
    const res = await fetch(url, { headers: { Accept: 'application/json' } })
    return res.ok ? await res.text() : fallback
  } catch {
    return fallback
  }
}

/**
 * Fetches text and returns [params, result]; uses fallback on error or non-OK.
 */
export const fetchOrWithParams = async <T>(url: string, fallback: string, params: T): Promise<[T, string]> => {
  try {
    const res = await fetch(url, { headers: { Accept: 'application/json' } })
    return res.ok ? [params, await res.text()] : [params, fallback]
  } catch {
    return [params, fallback]
  }
}
